import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';

import { useDebugStore } from './store/debugStore.js';
import { initDebugStore } from './store/debugStore.js';
initDebugStore(useDebugStore.getState().log);

// If accessed via path without hash (e.g. /room/id or /join/id), redirect to hash route
if (!window.location.hash && (window.location.pathname.startsWith('/room/') || window.location.pathname.startsWith('/join/'))) {
  window.location.replace('/#' + window.location.pathname + window.location.search);
}

// Restore persisted debug console state from settings.
try {
  const raw = localStorage.getItem('vcall.settings');
  if (raw) {
    const settings = JSON.parse(raw);
    useDebugStore.getState().setEnabled(!!settings['debugConsole']);
  }
} catch {
  // Ignore corrupted storage.
}

window.addEventListener('keydown', (e) => {
  if (e.ctrlKey && e.shiftKey && e.key === 'D') {
    e.preventDefault();
    useDebugStore.getState().setEnabled(!useDebugStore.getState().enabled);
  }
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
